export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_01.760b5ea8.jpg";